import { getDataEnv } from "src/api/services/env/envApi";

let envResponse: EnvType = null;
export type EnvType = {
  env?: string;
  domain?: string;
  resellApiHost: string;
  stripeKey: string;
  amandaBaseUrl: string;
  serviceAccount: string;
  resellOShiftHost: string;
  baseUrlIASearch: string;
  zaraStaticBaseUrl: string;
  zaraPreUrl:string;
  zaraHost:string;
  zaraReccomFlowHost:string;
  zaraHostLocations:string;
  growthBookHost: string;
  growthBookClientKey: string;
  growthBookDescriptionKey: string;
};
export async function searchEnvironment(): Promise<EnvType> {
  if (!envResponse) {
    envResponse = await getDataEnv();
  }
  return envResponse;
}

export function getEnv(): EnvType {
  return envResponse;
}
